// src/auth/NonMarshallReddickOnlyGuard.tsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

const blockedEmailDomain = '@marshallreddick.com';

export const NonMarshallReddickOnlyGuard = () => {
  const { isAuthenticated, email } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const normalizedEmail = email?.trim().toLowerCase() ?? null;
  const isMarshallReddickUser = !!normalizedEmail && normalizedEmail.endsWith(blockedEmailDomain);

  if (!normalizedEmail || isMarshallReddickUser) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
